import request from '../utils/request';
import { API_ENDPOINTS } from '../config/api';

export const statsAPI = {
  getOverview: () => {
    return request.get(API_ENDPOINTS.STATS_OVERVIEW);
  },
  getUserStats: () => {
    return request.get(API_ENDPOINTS.STATS_USERS);
  },
  getPostStats: () => {
    return request.get(API_ENDPOINTS.STATS_POSTS);
  },
  getTrends: (params) => {
    return request.get(API_ENDPOINTS.STATS_TRENDS, { params });
  },
  getLogs: (params) => {
    return request.get(API_ENDPOINTS.LOGS, { params });
  }
};
